import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, Calendar, Tag } from "lucide-react";
import { Badge } from "../components/ui/badge";
import Reveal from "../components/Reveal";
import { PageHero } from "./Services";
import { API } from "../lib/auth";
import Seo from "../components/Seo";

const fmtDate = (d) => new Date(d).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog`)
      .then((res) => setPosts(res.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="overflow-hidden">
      <Seo title="Blog — Marketing Tips & Insights" description="Practical digital marketing tips, SEO strategies, and lessons from the field to help local businesses win online." />
      <PageHero
        eyebrow="Blog"
        title="Marketing insights to grow your business"
        subtitle="Practical tips, strategies, and lessons from the field — written to help local businesses win online."
      />

      <section className="section-pad bg-white">
        <div className="mx-auto max-w-7xl px-6">
          {loading ? (
            <div className="text-center text-slate-400 py-20">Loading articles...</div>
          ) : posts.length === 0 ? (
            <div className="text-center text-slate-400 py-20">No articles published yet. Check back soon!</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 80}>
                  <Link to={`/blog/${p.slug}`} className="group flex flex-col h-full rounded-2xl border border-slate-200 bg-white overflow-hidden card-lift">
                    <div className="relative h-52 overflow-hidden">
                      <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                      <Badge className="absolute top-4 left-4 bg-white/90 text-blue-700 hover:bg-white font-semibold">
                        <Tag className="h-3 w-3 mr-1" />{p.category}
                      </Badge>
                    </div>
                    <div className="flex flex-col flex-1 p-6">
                      <div className="flex items-center gap-2 text-xs text-slate-400 font-medium">
                        <Calendar className="h-3.5 w-3.5" /> {fmtDate(p.created_at)}
                      </div>
                      <h3 className="mt-3 font-display text-xl font-bold text-slate-900 leading-snug group-hover:text-blue-600 transition-colors">
                        {p.title}
                      </h3>
                      <p className="mt-2 text-slate-600 leading-relaxed line-clamp-3 flex-1">{p.excerpt}</p>
                      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-blue-600">
                        Read article
                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                      </span>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blog;
